/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Date: 2021-07-24 14:05:45
 */
import { signIn } from '@/api/ajax.js';
export default function () {
  var _this = this;

  var that = this;
  var livingStatus = this.livingStore.livingStatus;
  var detail = this.livingStore.detail;

  if (livingStatus === 1) {
    this.$vux.toast.show({
      type: 'cancel',
      text: '直播尚未开始',
      position: 'middle',
      width: '6rem'
    });
    return;
  }

  if (livingStatus === 3) {
    this.$vux.toast.show({
      type: 'cancel',
      text: '直播已结束',
      position: 'middle',
      width: '6rem'
    });
    return;
  }

  if (detail.isSignIn) {
    this.$vux.toast.show({
      type: 'text',
      text: '您已签到',
      position: 'middle'
    });
    return;
  } // residenceTime 1S


  if (this.residenceTime < 60 * 5) {
    this.$vux.toast.show({
      type: 'text',
      text: '听课满5分钟才能签到',
      position: 'middle',
      width: '6rem'
    });
    return;
  }

  var wxUserInfo = this.$store.state.wxUserInfo;

  if (wxUserInfo.userDataStatus >= 2) {
    //如果完善信息了
    var data = {
      // type: 1,
      courseId: this.$route.params.id // isLiving: this.$route.query.isLiving

    };
    signIn.ansGetScore(data).then(function (res) {
      // if (this.$route.query.isLiving) {
      //   sa.track('qiandao', {
      //     course_id: this.$route.params.id,
      //     course_name: this.$route.params.id,
      //     course_type: 'live',
      //     client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
      //     client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
      //     from: 'wx',
      //     web_edition: 2
      //   });
      // } else {
      //   sa.track('qiandao', {
      //     course_id: this.$route.params.id,
      //     course_name: this.$route.params.id,
      //     course_type: 'video',
      //     client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
      //     client_id: wxUserInfo.id || wxUserInfo.wxOpenId,
      //     from: 'wx',
      //     web_edition: 2
      //   });
      // }
      var courseRouteName = 'liveDetail';

      if (res.data.stauts != 'error') {
        _this.$vux.toast.show({
          text: '恭喜您获得' + res.data.data.number + '积分',
          type: 'text',
          width: '5rem',
          onHide: function onHide() {
            that.$router.push({
              name: courseRouteName,
              params: {
                id: that.$route.params.id
              }
            });
          }
        });

        _this.$store.dispatch('living/init'); // 计时完成重新拉取数据

      } else {
        _this.$vux.toast.show({
          text: res.data.message,
          type: 'error',
          width: '5rem'
        });
      } //腊八签到活动上报
      // let hours = new Date().getHours()
      // if( hours > 18 && hours < 22 && this.$route.query.isLiving ){
      //   carveIntegralSignIn({courseId:data.courseId}).then(res=>{
      //
      //   })
      // }

    }); // setTimeout(function () {
    //   window.history.go(-1)
    // }, 2000)
  } else {
    //未完善信息,去完善
    this.$vux.toast.show({
      text: '获取积分前请您完善信息',
      type: 'text',
      width: '5rem',
      onHide: function onHide() {
        sessionStorage.goBackUrl = location.href;
        location.href = '/html/perfect.html#/perfect';
      }
    });
  }
}